module.exports = __webpack_public_path__ + "static/2front-you-1-e8a3e85102cd8b566e90bf8a0608668b.png";